import React from 'react';

import { NavLink, NavLinkProps } from 'react-router-dom';

type NavLinkV5Props = {
  to: string;
  exact?: boolean;
  activeClassName?: string;
  className?: string;
  children?: React.ReactNode;
};

/**
 * Adapter component that translates React Router v5 NavLink props to v7 API.
 * - `activeClassName` → `className` function that adds class when active
 * - `exact` → `end` prop
 */
const NavLinkAdapter: React.FC<NavLinkV5Props> = ({ to, exact, activeClassName, className, children }) => {
  const v7Props: NavLinkProps = {
    to,
    end: exact,
    className: ({ isActive }) => {
      const classes = [className];
      if (isActive && activeClassName) {
        classes.push(activeClassName);
      }
      return classes.filter(Boolean).join(' ');
    },
  };

  return <NavLink {...v7Props}>{children}</NavLink>;
};

export default NavLinkAdapter;
